<template>
  <div>
    <!-- 状态修改弹窗 -->
    <el-dialog
      v-if="innerVisible"
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SeaExport.UpdateStatus')"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px" label-position="left">
        <el-form-item :label="$t('SeaExport.ChooseState')">
          <el-select v-model="stateDialog.state" style="width:150px">
            <el-option
              v-for="(item) in SeaExportConstants.CONTAINER_STATE"
              :key="item.code"
              :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="stateDialog.state === 2" :label="$t('SeaExport.ActualPackingTime')">
          <el-date-picker v-model="stateDialog.actualLoadingTime" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" style="width:150px" />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="confirmEditState">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import { getLoading } from '@/utils/utilBaseElement'
import { updateContainerState } from '@/api/seaExport/container'

export default {
  name: 'UpdateContainerPoWindow',
  props: {
    visible: { type: Boolean, required: true },
    state: { type: Number, required: false, default: () => 0 },
    containerUuid: { type: String, required: true },
    actualPackingTime: { type: String, required: false }
  },
  data() {
    return {
      SeaExportConstants,
      loading: false,
      stateDialog: { // 更新状态
        state: '',
        containerUuid: '',
        actualLoadingTime: ''
      },
      innerVisible: false
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    toQuery() {
      this.stateDialog.state = this.state
      this.stateDialog.containerUuid = this.containerUuid
      this.stateDialog.actualLoadingTime = this.actualPackingTime
    },
    // 更改状态
    chooseState() {

    },
    // 确定修改状态
    confirmEditState() {
      if (this.stateDialog.state === 2 && !this.stateDialog.actualLoadingTime) {
        this.$message.warning(this.$t('SeaExport.ChooseActualPackingTime'))
        return
      }
      const item = {}
      item.anyStr = this.stateDialog.containerUuid
      item.anyStr1 = this.stateDialog.state
      item.anyStr2 = this.stateDialog.actualLoadingTime || ''
      // Container.updateContainerState(_value.uuid, _state, actualLoadingTime.selectedDate,updateResultHandler, faultHandler);
      this.loading = getLoading()
      updateContainerState(item).then(res => {
        const result = res.data
        if (result === 1) {
          this.$message.success(this.$t('CargoMsg.Cargo_UpdatedSuccessfully'))
          this.$emit('fun')
          const obj = {}
          obj.state = this.stateDialog.state
          obj.loadingDate = this.stateDialog.actualLoadingTime
          this.$emit('changeStateFun', obj)
          this.innerVisible = false
        } else if (result === -1) {
          this.$message.error(this.$t('SeaExport.updateContainerStateTip'))
        } else {
          this.$message.error(this.$t('CargoMsg.Cargo_UpdateFailed'))
        }
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss">
.el-loading-mask.is-fullscreen {
  z-index: 999999 !important;
}
</style>

